//----------------------------------------
// ScanSDK切替設定
//----------------------------------------
// 利用するスキャンSDK（scandit / barkoder / scanbot）を保持する
// 優先順位： URLパラメータ(?scan=) > localStorage > 既定値(scandit)

export const SCAN_SDK_SCANDIT = "scandit";
export const SCAN_SDK_BARKODER = "barkoder";
export const SCAN_SDK_SCANBOT = "scanbot";

//選択肢（設定画面の並び順
export const SCAN_SDK_LIST = [SCAN_SDK_SCANDIT, SCAN_SDK_BARKODER, SCAN_SDK_SCANBOT];

//既定のSDK
export const SCAN_SDK_DEFAULT = SCAN_SDK_SCANDIT;

//localStorageキー
const STORAGE_KEY = "regigo_scan_sdk";

//本番ドメイン（ScanSDKは選択制にせず、envの指定で固定する
const FIXED_SCAN_SDK_DOMAIN = "miniapp.regigo.jp";

//SDK名として正しいか
function isValidScanSdk(value) {
	return SCAN_SDK_LIST.indexOf(value) !== -1;
}

//----------------------------------------
//ScanSDK固定（本番）かどうか
//----------------------------------------
// true の場合：
//   ・利用するSDKは REACT_APP_SCAN_SDK で固定（URLパラメータ・localStorageは無視
//   ・設定画面への導線（#globalNav のScanSDK設定ボタン）は非表示

export function isScanSdkFixed() {
	if (typeof window === "undefined") {
		return false;
	}
	return window.location.host === FIXED_SCAN_SDK_DOMAIN;
}

//envで指定されたScanSDK（未設定・不正値は既定値
function getFixedScanSdk() {
	const value = process.env.REACT_APP_SCAN_SDK;
	if (isValidScanSdk(value)) {
		return value;
	}
	console.log("【ScanSDK】REACT_APP_SCAN_SDK が未設定または不正のため既定値を使用: " + SCAN_SDK_DEFAULT);
	return SCAN_SDK_DEFAULT;
}

//----------------------------------------
//ScanSDK取得
//----------------------------------------

export function getScanSdk() {
	if (typeof window === "undefined") {
		return SCAN_SDK_DEFAULT;
	}

	//本番はenvで固定（URLパラメータ・localStorageは参照しない
	if (isScanSdkFixed()) {
		return getFixedScanSdk();
	}

	//URLパラメータ（?scan=barkoder など）優先：指定時はlocalStorageにも保存
	try {
		const param = new URLSearchParams(window.location.search).get("scan");
		if (isValidScanSdk(param)) {
			saveScanSdk(param);
			return param;
		}
	} catch (e) {
		console.log("getScanSdk: urlParams error, " + e);
	}

	//localStorage
	try {
		const stored = window.localStorage.getItem(STORAGE_KEY);
		if (isValidScanSdk(stored)) {
			return stored;
		}
	} catch (e) {
		console.log("getScanSdk: localStorage error, " + e);
	}

	return SCAN_SDK_DEFAULT;
}

//----------------------------------------
//ScanSDK保存
//----------------------------------------

export function saveScanSdk(scanSdk) {
	//本番はenv固定のため保存しない
	if (isScanSdkFixed()) {
		return getFixedScanSdk();
	}
	if (!isValidScanSdk(scanSdk)) {
		return SCAN_SDK_DEFAULT;
	}
	try {
		window.localStorage.setItem(STORAGE_KEY, scanSdk);
	} catch (e) {
		console.log("saveScanSdk: localStorage error, " + e);
	}
	return scanSdk;
}
